module.exports = __webpack_public_path__ + "static/media/skype.fc7bfaeb.svg";